import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useNotificationStore = defineStore('notification', () => {
    // Initialize from localStorage if available
    const storedCount = localStorage.getItem('unreadHotNewsCount')
    const unreadHotNewsCount = ref(storedCount ? parseInt(storedCount) : 0)
    const isConnected = ref(false)

    // Persist changes to localStorage
    watch(unreadHotNewsCount, (val) => {
        localStorage.setItem('unreadHotNewsCount', val.toString())
    })

    const incrementHotNews = (count = 1) => {
        unreadHotNewsCount.value = Math.max(0, unreadHotNewsCount.value + count)
    }

    const clearHotNews = () => {
        unreadHotNewsCount.value = 0
    }

    const setUnreadCount = (count) => {
        unreadHotNewsCount.value = count
    }

    const setConnected = (status) => {
        isConnected.value = status
    }

    return {
        unreadHotNewsCount,
        isConnected,
        incrementHotNews,
        clearHotNews,
        setConnected,
        setUnreadCount
    }
})
